import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import { AuthenticatedLayout } from "./layouts/AuthenticatedLayout";
import { routerData } from "./configs/RouterConfig";
import { DefaultLayout } from "./layouts/DefaultLayout";
import { AdminRoute } from "./routes/AdminRoute";
import { AdminOrEmployeeRoute } from "./routes/AdminOrEmployeeRoute";
import { PublicRoute } from "./routes/PublicRoute";
import { Suspense } from "react";
import { useAuth } from "./context/AuthContext";
import { Toaster } from "./components/ui/toaster";
import ReactQueryProvider from "./context/ReactQueryProvider";
import { DeleteModalProvider } from "./context/DeleteModalProvider";

const LoadingFallback = () => (
  <div className="flex items-center justify-center min-h-screen">
    <p className="text-lg font-semibold">Loading...</p>
  </div>
);

const CreateRoutes = () => {
  const { user } = useAuth();

  return (
    <Suspense fallback={<LoadingFallback />}>
      <ReactQueryProvider>
        <Router>
          <Routes>
            {routerData(user)?.map((route, i) => {
              const Layout =
                route?.layout === "auth" ? AuthenticatedLayout : DefaultLayout;

              return (
                <Route
                  key={route?.key || i?.toString()}
                  path={route?.path}
                  element={
                    route?.routeType ? (
                      route?.routeType === "admin" ? (
                        <AdminRoute>
                          <Layout metaTitle={route?.title} />
                        </AdminRoute>
                      ) : route?.routeType === "adminOrEmployee" ? (
                        <AdminOrEmployeeRoute>
                          <Layout metaTitle={route?.title} />
                        </AdminOrEmployeeRoute>
                      ) : (
                        route?.routeType === "public" && (
                          <PublicRoute>
                            <Layout metaTitle={route?.title} />
                          </PublicRoute>
                        )
                      )
                    ) : (
                      <Layout metaTitle={route?.title} />
                    )
                  }
                >
                  <Route
                    path={route?.path}
                    exact
                    element={<route.component />}
                  />
                  {route?.subRoute?.map((sub, j) => (
                    <Route
                      key={j?.toString()}
                      path={sub?.path}
                      exact
                      element={<sub.component />}
                    />
                  ))}
                </Route>
              );
            })}
            {/* Fallback route */}
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
          <Toaster />
        </Router>
      </ReactQueryProvider>
    </Suspense>
  );
};

export default CreateRoutes;
